import { renderMessageText } from './components/message-text-renderer.js'

function installStreamMethods(Widget) {
  Widget.prototype._handleStreamEvent = function (eventName, data, fallbackUserText) {
    if (eventName === 'thinking') {
      return
    }
    if (eventName === 'newskill') {
      this._hideTyping()
      this._showTransientStatus(
        "J'appelle " + (data.displayName || data.label || data.code || "l'agent"),
        { kind: 'newskill', skill: data }
      )
      this._applyMissionState(this._normalizeNewSkillState(data))
      this._showTyping()
      return
    }
    if (eventName === 'stepstart') {
      this._hideTyping()
      this._showTransientStatus(this._resolveTransientStatusText(data), { kind: 'stepstart', step: data })
      this._showTyping()
      return
    }
    if (eventName === 'done') {
      this._hideTyping()
      this._hideTransientStatus()
      if (typeof this._refreshTokenQuota === 'function') this._refreshTokenQuota()
      return
    }
    if (eventName === 'stepdone') {
      this._hideTyping()
      this._hideTransientStatus()
      if (hasRenderableGatewayPayload(this, data)) {
        this._handleGatewayResponse(data, fallbackUserText)
      }
      this._showTyping()
      return
    }
    if (eventName === 'chatdelta') {
      this._hideTyping()
      this._hideTransientStatus()
      this._appendStreamingChatDelta(data)
      return
    }
    if (eventName === 'conv') {
      this._hideTyping()
      this._hideTransientStatus()
      if (this._streamingChatMessage) {
        this._handleGatewayResponse(data, fallbackUserText, {
          replaceStreamingElement: this._streamingChatMessage
        })
        this._streamingChatMessage = null
      } else {
        this._handleGatewayResponse(data, fallbackUserText)
      }
      return
    }
    if (eventName === 'error') {
      this._hideTyping()
      this._hideTransientStatus()
      this._append('Erreur réseau: ' + ((data && data.message) || ''), 'bot')
      this._applyMissionState(null)
    }
  }

  Widget.prototype._sendStreamingChat = function (payload, fallbackUserText) {
    return this._sendStreamRequest('/gateway/stream', payload, function (eventName, data) {
      this._handleStreamEvent(eventName, data, fallbackUserText)
    }.bind(this)).catch(function (err) {
      this._handleRequestError(err)
    }.bind(this))
  }

  Widget.prototype._sendStreamRequest = function (path, payload, onEvent, retried) {
    var self = this
    return fetch(this.apiUrl.replace(/\/?$/, '') + path, {
      method: 'POST',
      headers: Object.assign(
        { 'Content-Type': 'application/json', 'Accept': 'text/event-stream' },
        this.authToken && !this.useCookieAuth ? { Authorization: 'Bearer ' + this.authToken } : {}
      ),
      body: JSON.stringify(payload),
      credentials: this.useCookieAuth ? 'include' : 'same-origin'
    }).then(function (response) {
      if (response.status === 401 && !retried) {
        return self._recoverAuthSession().then(function () {
          return self._sendStreamRequest(path, payload, onEvent, true)
        })
      }
      if (!response.ok) {
        return response.text().then(function (text) {
          var body = null
          if (text) {
            try { body = JSON.parse(text) } catch (err) { body = { message: text } }
          }
          var error = new Error((body && body.message) || 'HTTP ' + response.status)
          error.status = response.status
          error.body = body
          throw error
        })
      }
      if (!response.body || !response.body.getReader) throw new Error('Streaming non supporté')
      return self._consumeSseStream(response.body.getReader(), onEvent)
    })
  }

  Widget.prototype._appendStreamingChatDelta = function (data) {
    var text = data && typeof data.text === 'string' ? data.text : ''
    if (!text) return
    if (!this._streamingChatMessage) {
      this._streamingChatMessage = this._append('', 'bot', { suppressActions: true })
    }
    this._updateStreamingChatMessage(this._streamingChatMessage, text)
  }

  Widget.prototype._updateStreamingChatMessage = function (messageEl, text) {
    if (!messageEl) return
    var body = messageEl.querySelector ? messageEl.querySelector('.wc-message-body') : null
    if (!body) return
    body.innerHTML = renderStreamMessageText(text)
    messageEl.setAttribute('data-wc-streaming', 'true')
    this._scrollToBottom()
  }

  Widget.prototype._finalizeStreamingChatMessage = function (messageEl, text, meta) {
    if (!messageEl) return
    messageEl.removeAttribute('data-wc-streaming')
    messageEl.classList.remove('wc-intro-message')
    if (typeof this._createAssistantMessageActions !== 'function') return
    if (messageEl.querySelector && messageEl.querySelector('.wc-message-actions')) return
    messageEl.appendChild(this._createAssistantMessageActions(Object.assign({ copyText: text }, meta || {})))
  }

  Widget.prototype._consumeSseStream = async function (reader, onEvent) {
    var decoder = new TextDecoder('utf-8')
    var buffer = ''
    var currentEvent = ''
    var dataLines = []

    function flush() {
      if (!currentEvent && !dataLines.length) return
      var raw = dataLines.join('\n')
      dataLines = []
      var parsed = null
      try { parsed = JSON.parse(raw) } catch (e) { parsed = raw }
      if (onEvent) onEvent(currentEvent || 'message', parsed)
      currentEvent = ''
    }

    while (true) {
      var result = await reader.read()
      if (result.done) break
      buffer += decoder.decode(result.value, { stream: true })
      var lines = buffer.split(/\r?\n/)
      buffer = lines.pop() || ''
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i]
        if (!line) {
          flush()
          continue
        }
        if (line.indexOf('event:') === 0) {
          currentEvent = line.slice(6).trim()
          continue
        }
        if (line.indexOf('data:') === 0) {
          dataLines.push(line.slice(5).trim())
        }
      }
    }
    flush()
  }
}

function hasRenderableGatewayPayload(widget, payload) {
  var result = payload && payload.result ? payload.result : null
  if (!result) return false
  var responseUi = widget && typeof widget._resolveResponseUi === 'function'
    ? widget._resolveResponseUi(result)
    : null
  if (responseUi) {
    if (responseUi.criteriaUi) return true
    if (responseUi.emailBriefUi) return true
    if (responseUi.emailSenderUi) return true
    if (responseUi.emailGenerateUi) return true
    if (responseUi.emailAdaptiveEstimateUi) return true
    if (responseUi.emailPreviewUi) return true
    if (responseUi.emailSendUi) return true
    if (responseUi.fieldSummaryUi) return true
    if (responseUi.capabilityBlockViewUi) return true
    if (responseUi.tableUi) return true
  }

  return Boolean(result.stepResult && result.stepResult.message)
}

function renderStreamMessageText(value) {
  return renderMessageText(value)
}

export { installStreamMethods }
